
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P22-E1',
    audio: '',
    video: '',
    component: D1,
    isAllowSubmit: true,
    maxLength: 3,
    textAlign: 'center',
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page22/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page22/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page22/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/3.jpg', input: true, answer: "50" },
        { url: 'img/FriendsPlus/Page22/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/5.jpg', input: true, answer: "70" },
        { url: 'img/FriendsPlus/Page22/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/7.jpg', input: true, answer: "40" },
        { url: 'img/FriendsPlus/Page22/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/9.jpg', input: true, answer: "80" },
        { url: 'img/FriendsPlus/Page22/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/11.jpg', input: true, answer: "60" },
        { url: 'img/FriendsPlus/Page22/E1/12.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page22/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/14.jpg', input: true, answer: "100" },
        { url: 'img/FriendsPlus/Page22/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/16.jpg', input: true, answer: "20" },
        { url: 'img/FriendsPlus/Page22/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/18.jpg', input: true, answer: "90" },
        { url: 'img/FriendsPlus/Page22/E1/19.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page22/E1/20.jpg' },
      ],
    ]
  },

  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P22-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page22/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page22/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page22/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page22/E2/3.jpg', input: true, answer: "thirty" },
        { url: 'img/FriendsPlus/Page22/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page22/E2/5.jpg', input: true, answer: "fifty" },
        { url: 'img/FriendsPlus/Page22/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page22/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page22/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page22/E2/9.jpg', input: true, answer: "sixty" },
        { url: 'img/FriendsPlus/Page22/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page22/E2/11.jpg', input: true, answer: "eighty" },
        { url: 'img/FriendsPlus/Page22/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page22/E2/13.jpg', input: true, answer: "one hundred" },
        { url: 'img/FriendsPlus/Page22/E2/14.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page22/E2/15.jpg' },
      ],

    ]
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P22-E3',
    audio: 'img/FriendsPlus/Page22/Audio/audio-e3-p22.mp3',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page22/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page22/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/tieude-e3-p22.mp3' },
        { url: 'img/FriendsPlus/Page22/E3/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page22/E3/4.jpg' },
      ],

    ]
  },


}

export default json;